module.exports = __webpack_public_path__ + "img/FNB.aa870c1c.svg";